'use client'
import React from 'react';
import styled from "styled-components";
import {Img} from "./Img";
import {Container} from "react-bootstrap";
import parser from "html-react-parser";
import {bold, white} from "@/styles/globalStyleVars";
import useDeviceTypeMobile from "@/components/hooks/useDeviceTypeMobile";
import {CURSOR_TEXT, DispatchCursor} from "haspr-cursor";

const InnerBanner = ({mimg,img,title,service, data}) => {

    const isMobile = useDeviceTypeMobile()

    return (
        <StyledInnerBanner className='InnerBanner parallax' service={service}>
            {
                isMobile ?
                    <Img banner={true} src={mimg ? mimg : img}/>
                    :
                    <Img className={'parallax'} data-speed="0.8"  parallax banner={true} src={img}/>
            }
            <Container>
                <h1 className={`split-up`}>{parser(title)}</h1>
            </Container>
        </StyledInnerBanner>
    );
};

const StyledInnerBanner = styled.section`
    padding-top: ${props => props.service ? `` : `calc(400 / 1366 * 100%)`};
    position: relative;
    background-color: #DDD;
    height: ${props => props.service ? `100vh` : ``};;

    .parallax {
        transform: scale(1.2);
    }

    &:after {
        content: '';
        position: absolute;
        //background-color: rgba(0, 0, 0, 0.25);
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
    }

    .container {
        position: absolute;
        //height: 100%;
        //top: 0;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 60px;
        z-index: 2;
    }

    p {
        line-height: 20px;
        padding-bottom: 20px;
        margin-bottom: 40px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    h1 {
        //position: absolute;
        left: 15px;
        //bottom: 94px;
        color: #ffffff;
        //text-transform: capitalize;
        z-index: 2;
        font-size: 60px;
        line-height: 70px;
        font-family: ${bold};


        span {
            font-weight: 600;
            color: ${white};
        }
    }

    @media (min-width: 767px) {
        .title {
            width: 50%;
        }
    }

    @media (max-width: 767px) {
        h1 {
            font-size: 40px;
            line-height: 44px;
        }

        //padding-top: 0;
        padding-top: calc(560 / 414 * 100%);
        .container {
            bottom: 69px;
        }

        .title {
            margin-bottom: 40px !important;
        }
    }
`;

export default InnerBanner;
